<template>
    <div v-if="brands.length > 0" class="section__brands mb-18">
        <div class="flex justify-content-between align-items-end mb-8">
            <h2 class="m-0 tx-30" style="text-transform: uppercase; margin: 0 auto;">
                Marcas
            </h2>
            <a class="see_all" href="/marcas">
                Ver todos >
            </a>
        </div>
        <div class="brands__grid grid">
            <a v-for="(brand, key) in brands" :key="key" class="item-thumbnail" :href="'/catalogo?brands=' + brand.id">
                <div class="wrapper-image">
                    <img class="logo" :src="'/files/brands/' + brand.image" :alt="brand.title">
                </div>
                <p class="name m-0">
                    {{ brand.title }}
                </p>
            </a>
        </div>
    </div>
</template>

<script>
export default {

    data() {
        return {
            brands: [],

            formData: null,
            err: {}
        }
    },

    created() {
        let vm = this;
        vm.getBrandsAsync();
    },

    methods: {
        async getBrandsAsync(position) {
            let vm = this;

            try {

                let {data} = await axios.get('/client/home/top-brands');
                vm.brands = data;

            } catch (error) { }
        },

        showErrors(error = null) {
            let vm = this;
            if ( error ) {
                vm.err = error.response.data;
            }
            vm.$swal({
                icon: 'error',
                title: 'Error',
                text: vm.err.message ? vm.err.message : 'Se encontraron algunos errores en el formulario',
            });
        },

        resetForms() {
            let vm = this;
            vm.formData = new FormData();
            vm.err = [];
        },
    }

}
</script>
